"use client"
import React, {Suspense} from 'react';
import Link from "next/link";
import {BiLogoGithub, BiLogoInstagram, BiLogoTelegram} from "react-icons/bi";
import ButtonAppLogo from "@/components/ui/buttons/logo/ButtonAppLogo";
import CircularProgressIndicator from "@/components/ui/main/CircularProgressIndicator";

const MainFooter = () => {

    return (
        <footer className="bg-white dark:bg-stone-950">
            <div className="mx-auto w-full max-w-screen-xl p-4 py-6 lg:py-8">
                <div className="md:flex md:justify-between">
                    <div className="mb-6 md:mb-0">
                        <Link
                            href={`/`}
                            className="-m-1.5 p-1.5 flex items-center"
                        >
                            <ButtonAppLogo/>
                        </Link>
                    </div>
                    <div className="grid grid-cols-2 gap-8 sm:gap-6 sm:grid-cols-5">
                        {/*<div>*/}
                        {/*    <div className={'flex'}>*/}
                        {/*        <Suspense fallback={<CircularProgressIndicator/>}>*/}
                        {/*            <a referrerPolicy='origin' target='_blank'*/}
                        {/*               href='https://trustseal.enamad.ir/?id=634665&Code=rYxrP81VtZrX0LIoLw9KywYYBAPA1Q2u'><img*/}
                        {/*                referrerPolicy='origin'*/}
                        {/*                src='https://trustseal.enamad.ir/logo.aspx?id=634665&Code=rYxrP81VtZrX0LIoLw9KywYYBAPA1Q2u'*/}
                        {/*                alt='اینماد'*/}
                        {/*                // style='cursor:pointer'*/}
                        {/*                // code='rYxrP81VtZrX0LIoLw9KywYYBAPA1Q2u'*/}
                        {/*            /></a>*/}
                        {/*        </Suspense>*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                        <div>
                            <h2 className="mb-6 text-sm font-semibold text-stone-950 uppercase dark:text-white">
                                {"منابع"}
                            </h2>
                            <ul className="text-stone-500 dark:text-stone-400 font-medium">
                                <li className="mb-4">
                                    <Link href="https://flowbite.com/" className="hover:underline">
                                        Flowbite
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        href="https://tailwindcss.com/"
                                        className="hover:underline"
                                    >
                                        Tailwind CSS
                                    </Link>
                                </li>
                            </ul>
                        </div>
                        <div>
                            <h2 className="mb-6 text-sm font-semibold text-stone-950 uppercase dark:text-white">
                                {"مارا دنبال کنید"}
                            </h2>
                            <ul className="text-stone-500 dark:text-stone-400 font-medium">
                                <li className="mb-4">
                                    <Link
                                        href="https://github.com/learnara"
                                        className="hover:underline "
                                    >
                                        گیتهاب
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        href="https://www.linkedin.com/company/learnara"
                                        className="hover:underline"
                                    >
                                        لینکدین
                                    </Link>
                                </li>
                            </ul>
                        </div>
                        <div>
                            <h2 className="mb-6 text-sm font-semibold text-stone-950 uppercase dark:text-white">
                                {"حقوقی"}
                            </h2>
                            <ul className="text-stone-500 dark:text-stone-400 font-medium">
                                <li className="mb-4">
                                    <Link href={`/privacy-policy`} className="hover:underline">
                                        {"حریم خصوصی"}
                                    </Link>
                                </li>
                                <li>
                                    <Link href={`/terms`} className="hover:underline">
                                        {"قانون و مقررات"}
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <hr className="my-6 border-stone-200 sm:mx-auto dark:border-stone-700 lg:my-8"/>
                <div className="sm:flex sm:items-center sm:justify-between">
                <span className="text-sm text-stone-500 sm:text-center dark:text-stone-400">
                    © 2025{" "}
                    <Link href="https://Learnara.ir/" className="hover:underline">
                        Learnara™
                      </Link>
                    . All Rights Reserved.
                </span>
                    <div className="flex items-center mt-4 sm:justify-center sm:mt-0">
                        {[
                            {name: 'Channel', link: 'https://t.me/learnara_ir', logo: <BiLogoTelegram/>},
                            {name: 'GitHub', link: 'https://github.com/learnara', logo: <BiLogoGithub/>},
                            {name: 'Instagram', link: 'https://instagram.com/learnara_ir', logo: <BiLogoInstagram/>},
                        ].map(value => <Link
                                key={'social-' + value.name}
                                target={'_blank'}
                                className={'flex items-center gap-1 text-xl py-1 px-3 text-stone-500 hover:text-stone-950 hover:dark:text-white transition-all duration-300'}
                                href={value.link}>
                                {value.logo}
                            </Link>
                        )}
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default MainFooter;
